import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Button from './Button'
import Dialog from './Dialog'
import './Confirm.css'

class Confirm extends Component {
  render () {
    return (
      <Dialog title={this.props.title} actions={this.renderActions()} onClose={this.onCancel.bind(this)}>
        {this.props.children}
      </Dialog>
    )
  }

  renderActions () {
    const modifier = this.props.isDangerous ? 'danger' : null
    return [
      <Button key='confirm_cancel_action' onClick={this.onCancel.bind(this)} style='square' inverse modifier='secondary'>
        {this.props.cancelText}
      </Button>,
      <Button disabled={this.props.disabled} key='confirm_confirm_action' onClick={this.onConfirm.bind(this)} style='square' modifier={modifier}>
        {this.props.confirmText}
      </Button>
    ]
  }

  onConfirm () {
    if (this.props.onConfirm) {
      this.props.onConfirm()
    }
    if (!this.props.skipCloseOnConfirm) this.onClose()
  }

  onClose () {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  onCancel () {
    if (this.props.onCancel) {
      this.props.onCancel()
    }
    this.onClose()
  }
}

Confirm.displayName = 'Confirm'

Confirm.defaultProps = {
  cancelText: 'Cancel',
  skipCloseOnConfirm: false
}

Confirm.propTypes = {
  cancelText: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  confirmText: PropTypes.string,
  isDangerous: PropTypes.bool,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  skipCloseOnConfirm: PropTypes.bool,
  title: PropTypes.string
}

export default Confirm



// WEBPACK FOOTER //
// ./ui/Confirm.js